export function initScrolledLogoSwap() {
  const headerGroup = document.querySelector(
    ".shopify-section-group-header-group",
  );
  const headerTop = document.querySelector(".c-header-top");
  const headerLogo = document.querySelector(".header-logo-link");
  const scrolledLogo = document.querySelector(".header-logo-link--scrolled");

  if (!headerGroup || !headerTop) return;

  const isMobile = () => window.innerWidth <= 900;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function setHeaderOffsets(isMobileHeaderPeeking, topBarH, scrollY) {
    const mainHeaderHeight = Math.max(0, headerGroup.offsetHeight - topBarH);
    const desktopHeaderHeight =
      scrollY > topBarH ? mainHeaderHeight : headerGroup.offsetHeight;

    document.documentElement.style.setProperty(
      "--mobile-main-header-height",
      `${mainHeaderHeight}px`,
    );
    document.documentElement.style.setProperty(
      "--tabs-nav-desktop-offset",
      `${desktopHeaderHeight}px`,
    );
    document.body.classList.toggle(
      "mobile-header-peeking",
      isMobileHeaderPeeking,
    );
  }

  function update() {
    const scrollY = window.scrollY;
    const topBarH = headerTop.offsetHeight;
    const mobile = isMobile();
    let headerIsPeeking = false;

    if (!mobile) {
      // Desktop: slide top bar away when scrolled past it, main header stays visible
      headerGroup.style.transform =
        scrollY > topBarH ? `translateY(-${topBarH}px)` : "translateY(0)";

      // Logo swap
      if (headerLogo && scrolledLogo) {
        if (scrollY > 50) {
          headerLogo.classList.add("is-scrolled");
          scrolledLogo.classList.add("is-visible");
        } else {
          headerLogo.classList.remove("is-scrolled");
          scrolledLogo.classList.remove("is-visible");
        }
      }
    } else {
      // Mobile:
      // at top → show everything
      // scroll down past 80px → hide everything
      // scroll up intent → peek main header (hide only top bar)
      if (scrollY <= topBarH) {
        headerGroup.style.transform = "translateY(0)";
      } else if (scrollY > lastScrollY && scrollY > 80) {
        headerGroup.style.transform = "translateY(-100%)";
      } else if (scrollY < lastScrollY) {
        headerGroup.style.transform = `translateY(-${topBarH}px)`;
        headerIsPeeking = true;
      }

      // No logo swap on mobile
      if (headerLogo && scrolledLogo) {
        headerLogo.classList.remove("is-scrolled");
        scrolledLogo.classList.remove("is-visible");
      }
    }

    setHeaderOffsets(mobile && headerIsPeeking, topBarH, scrollY);

    lastScrollY = scrollY;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener("scroll", onScroll);
  window.addEventListener("resize", update);
  update();
}
